import React, { useContext, useEffect, useState } from "react";
import {
    Label,
    Wrapper,
    SingleValueWrapper,
    OptionWrapper,
} from "./styled.js";
import SelectAsync from 'react-select/lib/Async';
import { fetchParts } from "./service";
import { AppContext } from "hocs/withAppContext";

const SingleValue = ({ innerProps, innerRef, data }) =>
    <SingleValueWrapper ref={innerRef} {...innerProps}>
        {data.stringPartName}
    </SingleValueWrapper>;

const Option = ({ innerProps, innerRef, data}) => {
    const { currencySymbol } = useContext(AppContext);

    return <OptionWrapper ref={innerRef} {...innerProps}>
        <p>{data.stringPartName}</p>
        <div>
            {data.numberPartCost && <p>Cost: {currencySymbol} {data.numberPartCost}</p>}
            {data.stringPartQuantity && <p>Quantity: {data.stringPartQuantity}</p>}
        </div>
    </OptionWrapper>;
};

export const SelectPart = ({ label, placeholder, required,
                             value = '', onChange, error }) => {
    const { role } = useContext(AppContext);
    const roleId = role.objectId;

    const [defaultOptions, setDefaultOptions] = useState([]);
    useEffect(() => {
        fetchParts(roleId).then(setDefaultOptions);
    }, [roleId]);

    return <Wrapper className="select-box">
        {label && <Label required={required}>{label}</Label>}
        <SelectAsync
            className={ error ? 'data-error': ''}
            classNamePrefix="react-select"
            placeholder={placeholder}
            required={required}
            defaultOptions={defaultOptions}
            loadOptions={q => fetchParts(roleId, q)}
            components={{ SingleValue, Option }}
            isClearable={true}
            value={value}
            onChange={onChange}
        />
    </Wrapper>
};

export default SelectPart;
